import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import "./board.css";
import "./app.css";
import "./cards.css";
import "./panels.css";
import "./icons.css";
import "./orgs.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
